import React from "react";
import { FaLock } from "react-icons/fa";

/**
 * The gradient Pay button. Label changes based on payment state:
 *   idle       → "Pay <amountDisplay> with wallet"
 *   switching  → "Switching network…"
 *   signing    → "Sign in wallet…"
 *   submitting → "Settling payment…"
 *   error      → "Try again"
 *
 * Button stays clickable in `error` so the user can retry; disabled
 * during the live-flow states to prevent double-signing. Spinner
 * could be added later — label changes are enough signal for v1.
 */
export function PayButton({ link, status, onClick }) {
  let label;
  let disabled = false;
  switch (status) {
    case "switching":
      label = "Switching network…";
      disabled = true;
      break;
    case "signing":
      label = "Sign in wallet…";
      disabled = true;
      break;
    case "submitting":
      label = "Settling payment…";
      disabled = true;
      break;
    case "error":
      label = "Try again";
      break;
    default:
      label = `Pay ${link?.amountDisplay || ""} with wallet`;
  }

  return (
    <button
      type="button"
      className="pay-button"
      onClick={onClick}
      disabled={disabled}
    >
      <FaLock size={14} />
      {label}
    </button>
  );
}
